import {
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  List,
  TextField,
  Create,
  DateInput,
} from "react-admin";

export const CustomerList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField label="First" source="firstName" />
      <TextField label="Last" source="lastName" />
      <TextField label="Email" source="emails[0].email" />
      <TextField label="Phone" source="phones[0].number" />
    </Datagrid>
  </List>
);


export const CustomerCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput  label="First Name" source="firstName" />
      <TextInput  label="Last Name" source="lastName" />
      <DateInput  label="Birthday" source="birthday" defaultValue={new Date('2000-01-01')}/>
      <TextInput  label="Email" source="emails[0].email" />
    </SimpleForm>
  </Create>
  );

export const CustomerEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput  label="First Name" source="firstName" />
      <TextInput  label="Last Name" source="lastName" />
      <DateInput  label="Birthday" source="birthday" defaultValue={new Date('2000-01-01')} />
      <TextInput  label="Email" source="emails[0].email" inputProps={{ size: 25 }}/>
    </SimpleForm>
  </Edit>
);
